import * as React from 'react';
import * as classNames from 'classnames';
import { Component } from 'react';
import * as debounce from 'debounce-promise';

interface Props {
  onSelect: (item: any) => void;
  searchFunction: (value) => any;
  getElementTitle: (item: any) => string;
  onEnterPress?: (event) => void;
  defaultText?: any;
  customClass?: string;
  disabled?: boolean;
}

interface State {
  isLoading: boolean;
  itemList: any[];
  isOpen: boolean;
  currentText: string;
}

export class AutocompleteFilter extends Component<Props, State> {
  searchFunctionDebounced: any;

  static defaultProps = {
    disabled: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      itemList: [],
      isOpen: false,
      currentText: '',
    };
  }

  componentDidMount() {
    const { searchFunction, defaultText } = this.props;
    this.searchFunctionDebounced = debounce(searchFunction, 500);
    if (defaultText !== '' || typeof defaultText !== 'undefined') {
      this.setState({
        currentText: defaultText,
      });
    }
  }

  /** Checks on new props if we need to set default item */
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { defaultText } = this.props;
    const { defaultText: nextDefaultText } = nextProps;
    // Eliminating infinite looping by checking if really props update take place
    if (nextDefaultText !== defaultText) {
      // Change current text (value in input field) on props.defaultItem, if received new props.defaultItem
      this.setState({
        currentText: nextDefaultText,
      });
    }
  }

  onChange = event => {
    event.preventDefault();
    const value = event.target.value;
    this.search(value);
  };

  onFocus = () => {
    const { currentText } = this.state;
    this.search(currentText);
  };

  search(value: string) {
    this.setState({
      isLoading: true,
      currentText: value,
    });

    this.searchFunctionDebounced(value).then(data => {
      this.setState(
        {
          isLoading: false,
          itemList: data,
          isOpen: true,
        },
        () => {
          document.addEventListener('click', this.closeMenu);
        }
      );
    });
  }

  closeMenu = () => {
    this.setState({ isOpen: false }, () => {
      document.removeEventListener('click', this.closeMenu);
    });
  };

  onItemClick = (event, item) => {
    event.preventDefault();
    const currentText = this.props.getElementTitle(item);

    this.setState({
      currentText: currentText,
      isOpen: false,
    });

    this.props.onSelect(item);
  };

  renderItems() {
    const { itemList } = this.state;

    if (itemList.length == 0) {
      return (
        <a href="" className="dropdown-item disabled">
          No results
        </a>
      );
    }

    return itemList.map((item, index) => {
      return (
        <a
          href=""
          className="dropdown-item"
          key={`autocomplete_${index}`}
          onClick={event => this.onItemClick(event, item)}
        >
          {this.props.getElementTitle(item)}
        </a>
      );
    });
  }

  render() {
    const { isLoading, isOpen, currentText } = this.state;

    const { customClass, disabled, onEnterPress } = this.props;
    const autocompleteClass = classNames('bAutocompleteFilter', customClass);

    return (
      <div className={autocompleteClass}>
        <input
          className="form-control eAutocompleteInput"
          value={currentText}
          onChange={this.onChange}
          onFocus={this.onFocus}
          onKeyDown={onEnterPress}
          disabled={disabled}
        />
        {isLoading && <div className={'spinner-border spinner-border-sm eAutocompleteSpinner'} />}

        {isOpen && <div className="dropdown-menu show">{this.renderItems()}</div>}
      </div>
    );
  }
}
